import { CardWrapper, FooterWrap } from "./style";
import { IconTags } from "views/components/Office/IconTags";
import {
	InlineReservable,
	InlineWait,
	InlineWaiting,
} from "views/mobile/components/icons";

import { getWaitStimated } from "lib/getWaitStimated";
import { pathOr } from "ramda";
import { useCurrentBreakpointName } from "react-socks";
import { useGlobal } from "reactn";
import { useTimeAndPeopleAhead } from "hooks/useTimeAndPeopleAhead";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import theme from "views/resources/theme";

const LineCard = ({ line, office, officeSlug, onSelect }) => {
	const [peopleAheadLocal, setPeopleAheadLocal] = useState(0);
	const avgElapsed = pathOr(0, ["raw_tickets", "avg_elapsed", "mean"], line);
	const attentionTypeTicket = pathOr(
		true,
		["options", "attention_type", "tickets"],
		office
	);

	const peopleAhead = line.waiting;

	const {
		wait,
		loading: loadingWait,
		realPeopleAhead,
	} = useTimeAndPeopleAhead(line, officeSlug);

	const realWaitStimated =
		wait && wait > 0
			? Math.min(Number(wait), 180) === 180
				? `+${Math.min(Number(wait), 180)}`
				: Math.min(Number(wait), 180) || "-"
			: loadingWait
			? "-"
			: getWaitStimated(peopleAhead, avgElapsed);

	useEffect(() => {
		setPeopleAheadLocal(realPeopleAhead);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [line]);

	const currentBp = useCurrentBreakpointName();

	const footer = (
		<CardFooter
			line={line}
			realPeopleAhead={peopleAheadLocal}
			wait={wait === 0 ? 0 : realWaitStimated}
		/>
	);

	const footerOnlyReserve = <FooterWrap>Solo reservas</FooterWrap>;

	const [config] = useGlobal("UIConfig");

	return (
		<CardWrapper
			title={line ? line.name : ""}
			onClick={() => onSelect(line)}
		>
			<div className="topInfo-Wrapper">
				<h3 style={currentBp === "mobile" ? { fontSize: "15px" } : {}}>
					{line ? line.name : <Skeleton />}
				</h3>
				<IconTags office={office} line={line} />
			</div>
			{config && !config.hideLineCardFooter && (
				<div>{attentionTypeTicket ? footer : footerOnlyReserve}</div>
			)}
		</CardWrapper>
	);
};

LineCard.defaultProps = {
	tickets: [],
};

const CardFooter = ({ wait, realPeopleAhead, line }) => {
	return (
		<FooterWrap>
			<InlineWaiting waiting={realPeopleAhead} size={0.7} />
			<InlineWait wait={wait} size={0.7} />
			{line && line.reservable && (
				<InlineReservable size={0.7} color={theme.colors.secondary} />
			)}
		</FooterWrap>
	);
};

export default LineCard;
